var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"i-btn i-file i-custom i-btn-white",attrs:{"for":"file-input"}},[_c('input',{staticClass:"file-input p-0",attrs:{"type":"file","name":"resume","accept":_vm.acceptFile,"id":"file-input"},on:{"change":function($event){return _vm.processFile($event)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }